module.exports = __webpack_public_path__ + "static/logo-39a43643a9af48047b0ed96c1b4e246d.svg";